import { render, staticRenderFns } from "./abilityNewCreate.vue?vue&type=template&id=3b15e542&scoped=true"
import script from "./abilityNewCreate.vue?vue&type=script&lang=js"
export * from "./abilityNewCreate.vue?vue&type=script&lang=js"
import style0 from "./abilityNewCreate.vue?vue&type=style&index=0&id=3b15e542&prod&lang=scss&scoped=true"
import style1 from "./abilityNewCreate.vue?vue&type=style&index=1&id=3b15e542&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b15e542",
  null
  
)

export default component.exports